import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { complianceAPI } from '@/api';
import type {
  AlertListRequest,
  AlertListResponse,
  AlertStatsResponse,
  BaseRequest,
  UpdateAlertStatusRequest,
} from '@/api';
import {
  complianceAlertStatsActions,
  complianceAlertsActions,
} from '@/redux/actions';
import { complianceAlertsMappers } from '@/redux/mappers';

function* fetchAlertStats(action: PayloadAction<BaseRequest>): SagaIterator {
  try {
    const { payload } = action;
    const response: AlertStatsResponse = yield call(
      complianceAPI.getAlertStats,
      payload,
    );

    const data = complianceAlertsMappers.fetchStats(response);
    yield put(complianceAlertStatsActions.setStats(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceAlertStatsActions.setLoading(false));
  }
}

function* fetchStatsAlertList(
  action: PayloadAction<AlertListRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: AlertListResponse = yield call(
      complianceAPI.listAlerts,
      payload,
    );

    const data = complianceAlertsMappers.fetchList(response);
    yield put(complianceAlertStatsActions.setList(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceAlertStatsActions.setLoading(false));
  }
}

function* listAlerts(action: PayloadAction<AlertListRequest>): SagaIterator {
  try {
    const { payload } = action;

    const response: AlertListResponse = yield call(
      complianceAPI.listAlerts,
      payload,
    );

    const data = complianceAlertsMappers.fetchList(response);
    yield put(complianceAlertsActions.setData(data));
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceAlertsActions.setLoading(false));
  }
}

function* updateStatus(
  action: PayloadAction<UpdateAlertStatusRequest>,
): SagaIterator {
  try {
    const { payload } = action;

    const response: AlertListResponse = yield call(
      complianceAPI.updateAlertStatus,
      payload,
    );

    if (!!response?.result && !!response?.data) {
      const data = { id: payload.id, status: payload.status };
      yield put(complianceAlertsActions.refreshAlertStatus(data));
      yield put(complianceAlertStatsActions.refreshAlertStatus(data));
    }
  } catch (error: unknown) {
    // console.log(error);
  } finally {
    yield put(complianceAlertsActions.setLoading(false));
  }
}

export { fetchAlertStats, fetchStatsAlertList, listAlerts, updateStatus };
